import { api } from './api';

export type SignalKind = 'budget_breach' | 'trend_spike' | 'new_account' | 'vanished_account';
export type SignalSeverity = 'high' | 'medium' | 'low';

export interface Signal {
  id: string;
  kind: SignalKind;
  accountCode: string;
  current: number;
  baseline: number | null;
  delta: number;
  deltaPct: number | null;
  direction: 'up' | 'down';
  severity: SignalSeverity;
  factIds: string[];
  summary: string;
}

export interface SignalsResult {
  periodStart: string;
  periodEnd: string;
  scenario: string;
  budgetScenario: string;
  signals: Signal[];
  scanned: { accounts: number; months: number };
}

export interface DetectInput {
  periodStart: string;
  periodEnd: string;
  scenario?: string;
  budgetScenario?: string;
  windowMonths?: number;
}

export const signalsApi = {
  detect: (wsId: string, input: DetectInput): Promise<SignalsResult> =>
    api.post(`/api/workspaces/${wsId}/signals`, input).then((r) => r.data),
};
